<template>
	<div style="display: flex;flex-wrap: wrap;">
		<div class="DownLoadList" v-for="(item,index) of DownLoadArr" :key="index">
			<div class="ListTop">
				<div class="Time">
					{{ item.UpdateTime }}
				</div>
				<div class="Info">
					<span v-if="item.Attachment">
						<img src="../../../../../../assets/channel/DownLoadIcon/Ex_File.png"
							style="width: 24px;height: 24px;" alt="" v-if="item.Attachment.Extension == 'xlsx'">
						<img src="../../../../../../assets/channel/DownLoadIcon/Word_File.png"
							style="width: 24px;height: 24px;" alt="" v-else-if="item.Attachment.Extension == 'docx'">
						<img src="../../../../../../assets/channel/DownLoadIcon/O_File.png"
							style="width: 24px;height: 24px;" alt="" v-else-if="item.Attachment.Extension == 'OutLook'">
						<img src="../../../../../../assets/channel/DownLoadIcon/P_File.png"
							style="width: 24px;height: 24px;" alt="" v-else-if="item.Attachment.Extension == 'ppt'">
						<img src="../../../../../../assets/channel/DownLoadIcon/Pdf_File.png"
							style="width: 24px;height: 24px;" alt="" v-else-if="item.Attachment.Extension == 'pdf'">
					</span>
					<span v-else>
						<img src="" alt="">
					</span>
					<div class="Icon-Text" v-if="item.Attachment">
						{{ item.Title }}
					</div>
				</div>

				<div class="Name">
					<div class="NameText">
						<img style="transform: translateY(6px);"
							src="../../../../../../assets/channel/homePng/listPer.png" alt="" class="user">
						{{ item.CreatorName }}
					</div>
					<img style="transform: translateY(6px);"
						src="../../../../../../assets/channel/DownLoadIcon/download.png" alt="" class="download"
						@click="DownLoadClick(item.Attachment)">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			DownLoadArr: {
				type: Array
			}
		},
		data() {
			return {

			}
		},
		created() {},
		mounted() {},
		activated() {},
		updated() {},
		methods: {
			DownLoadClick(item) {
				this.$emit("DownLoadClick")
				if (item.Extension == 'pdf') {
					window.open(item.FileUrl, "_blank")
					return
				}
				window.location.href = item.FileUrl
			}
		},
		computed: {},
		watch: {},
	}
</script>
<style scoped lang='less'>
	.DownLoadList:nth-child(4n) {
		margin-right: 0px;
	}

	.DownLoadList {
		border: 1px solid #ebedf0;
		display: inline-block;
		margin-right: 18px;
		margin-top: 20px;
		position: relative;
		top: -20px;
		user-select: none;

		.ListTop {
			width: 216px;
			height: 172px;
			background: #ffffff;
			border-radius: 4px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.Time {
				width: 100%;
				height: 40px;
				border-bottom: 1px solid #ebedf0;
				font-weight: 400;
				color: #9ca5b8;
				font-size: 14px;
				line-height: 40px;
				text-indent: 16px;
			}

			.Info {
				display: flex;
				padding: 10px;

				img {
					/* margin-left: 12px;
		  margin-top: 12px; */
					width: 24px;
					height: 24px;
					vertical-align: top;
					margin-right: 6px;
				}

				.Icon-Text {
					/* width: 190px;
		  height: 44px;
		  margin-top: 42px;
		  margin-left: 14px; */
					font-size: 16px;
					color: #16181a;
					font-weight: 500;
					display: inline-block;
				}
			}


			.Name {
				height: 50px;
				font-size: 14px;
				color: #9ca5b8;
				position: relative;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0px 12px;

				.NameText {
					/* position: absolute;
        display: inline-block;
        bottom: 16px;
        left: 48px; */
				}

				.user {
					width: 24px;
					height: 24px;
					/* position: absolute;
        bottom: 12px;
        left: 0px; */
					// border: 1px solid red;
				}

				.download {
					width: 16px;
					height: 16px;
					// border: 1px solid red;
					/*  position: relative;
        bottom: 10px;
        left: 238px; */
					cursor: pointer;
				}
			}
		}
	}
</style>
